"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BugsDropdown = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Dropdown = _interopRequireDefault(require("../../../Dropdown"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _TimeFrom = _interopRequireDefault(require("../TimeFrom/TimeFrom"));
var _MicCheckButton = _interopRequireDefault(require("../../Dialer/MicCheckButton"));
var _crm = require("../../../../icons-react/crm");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledDropdownIcon = _Dropdown["default"].StyledDropdownIcon;
var Sizes = _Button["default"].Sizes;
var BugsDropdown = exports.BugsDropdown = function BugsDropdown(_ref) {
  var className = _ref.className,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list,
    hasSocketError = _ref.hasSocketError,
    hasVoxError = _ref.hasVoxError,
    hasUpdates = _ref.hasUpdates,
    onCopy = _ref.onCopy,
    onReset = _ref.onReset,
    onToggle = _ref.onToggle,
    onOpenReport = _ref.onOpenReport;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hasNewBugs = _useState2[0],
    setNewBugs = _useState2[1];
  var _useState3 = (0, _react.useState)(list),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    savedList = _useState4[0],
    setList = _useState4[1];
  (0, _react.useEffect)(function () {
    if (list.length > 0 && list !== savedList) {
      setNewBugs(true);
      setTimeout(function () {
        setNewBugs(false);
        setList(list);
      }, 2000);
    }
  }, [list]);
  var headRenderer = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(StyledHead, {
      "data-socket-error": hasSocketError,
      "data-has-updates": hasUpdates
    }, /*#__PURE__*/_react["default"].createElement(_crm.Bug, {
      width: 13
    }), /*#__PURE__*/_react["default"].createElement(StyledLabel, null, list.length));
  }, [list, hasSocketError, hasUpdates, hasNewBugs]);
  var contentRenderer = (0, _react.useMemo)(function () {
    var isNotEmptyList = list.length > 0;
    return /*#__PURE__*/_react["default"].createElement(StyledContent, null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !!hasSocketError && /*#__PURE__*/_react["default"].createElement(StyledSocketError, null, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0430\u0432\u0442\u043E\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445.", /*#__PURE__*/_react["default"].createElement("br", null), "\u041F\u043E\u0434\u043E\u0436\u0434\u0438\u0442\u0435, \u043B\u0438\u0431\u043E \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 CRM."), !!hasVoxError && /*#__PURE__*/_react["default"].createElement(StyledVoxError, null, "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u044B \u0441\u0431\u043E\u0438 \u0432 \u0440\u0430\u0431\u043E\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438\u0438.", /*#__PURE__*/_react["default"].createElement("br", null), "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u0443\u0436\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043D\u0430\u0434 \u0438\u0445 \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u0435\u043C."), !!hasUpdates && /*#__PURE__*/_react["default"].createElement(StyledUpdates, null, "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043D\u043E\u0432\u044B\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F.", /*#__PURE__*/_react["default"].createElement("br", null), "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 CRM."), isNotEmptyList && /*#__PURE__*/_react["default"].createElement(StyledBugs, null, list.map(function (_ref2) {
      var title = _ref2.title,
        message = _ref2.message,
        description = _ref2.description,
        createdAt = _ref2.createdAt;
      return /*#__PURE__*/_react["default"].createElement(StyledBug, {
        key: "".concat(title, " + ").concat(createdAt),
        title: message
      }, /*#__PURE__*/_react["default"].createElement(StyledBugMeta, null, /*#__PURE__*/_react["default"].createElement(StyledPriorityIcon, null), /*#__PURE__*/_react["default"].createElement(StyledBugTitle, null, "".concat(title).concat(message ? " (".concat(message, ")") : "")), /*#__PURE__*/_react["default"].createElement(StyledBugTime, {
        time: createdAt
      })), /*#__PURE__*/_react["default"].createElement(StyledDescription, null, description));
    })), /*#__PURE__*/_react["default"].createElement(StyledButtons, null, isNotEmptyList && onCopy && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: onCopy,
      size: Sizes.TINY
    }, "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043B\u043E\u0433"), isNotEmptyList && onReset && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: onReset,
      size: Sizes.TINY
    }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043E\u0448\u0438\u0431\u043A\u0438"), onOpenReport && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: function onClick() {
        onOpenReport();
        onToggle === null || onToggle === void 0 || onToggle(false);
      },
      size: Sizes.TINY
    }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0440\u0435\u043F\u043E\u0440\u0442"), /*#__PURE__*/_react["default"].createElement(_MicCheckButton["default"], null))));
  }, [hasSocketError, hasVoxError, hasUpdates, list]);
  return /*#__PURE__*/_react["default"].createElement(StyledBugsDropdown, {
    className: className,
    headRenderer: headRenderer,
    contentRenderer: contentRenderer,
    hasNewBugs: hasNewBugs,
    hasSocketError: hasSocketError,
    hasUpdates: hasUpdates,
    onToggle: onToggle
  });
};
var StyledBugsDropdown = (0, _styledComponents["default"])(_Dropdown["default"]).withConfig({
  displayName: "BugsDropdown__StyledBugsDropdown",
  componentId: "sc-1dd3hpp-0"
})(["background:white;font-size:13px;position:relative;border:none;border-radius:4px;", "{display:none;}", ";", ";"], StyledDropdownIcon, function (_ref3) {
  var hasNewBugs = _ref3.hasNewBugs;
  return hasNewBugs && "\n    box-shadow: 0 0 4px #fc788f;\n    border-color: #fc788f;\n  ";
}, function (_ref4) {
  var hasUpdates = _ref4.hasUpdates;
  return hasUpdates && "\n    box-shadow: 0 0 4px #78c9fc;\n    border-color: #78c9fc;\n  ";
});
var StyledBug = _styledComponents["default"].div.withConfig({
  displayName: "BugsDropdown__StyledBug",
  componentId: "sc-1dd3hpp-1"
})(["padding:5px 0;"]);
var StyledBugMeta = _styledComponents["default"].div.withConfig({
  displayName: "BugsDropdown__StyledBugMeta",
  componentId: "sc-1dd3hpp-2"
})(["display:flex;column-gap:5px;align-items:center;text-align:left;"]);
var StyledBugs = _styledComponents["default"].div.withConfig({
  displayName: "BugsDropdown__StyledBugs",
  componentId: "sc-1dd3hpp-3"
})(["overflow-x:hidden;overflow-y:auto;max-height:400px;", "{border-top:1px solid #dadada;&:first-child{border-top:none;}}"], StyledBug);
var StyledButtons = _styledComponents["default"].div.withConfig({
  displayName: "BugsDropdown__StyledButtons",
  componentId: "sc-1dd3hpp-4"
})(["display:flex;justify-content:center;gap:10px;margin-bottom:10px;"]);
var StyledPriorityIcon = _styledComponents["default"].div.withConfig({
  displayName: "BugsDropdown__StyledPriorityIcon",
  componentId: "sc-1dd3hpp-5"
})(["width:9px;height:9px;border-radius:100%;background:#e21f4b;"]);
var StyledSocketError = _styledComponents["default"].div.withConfig({
  displayName: "BugsDropdown__StyledSocketError",
  componentId: "sc-1dd3hpp-6"
})(["border:1px solid #ffe4e4;border-radius:4px;background:#fff0f0;padding:4px 0;font-weight:bold;margin-bottom:5px;"]);
var StyledVoxError = (0, _styledComponents["default"])(StyledSocketError).withConfig({
  displayName: "BugsDropdown__StyledVoxError",
  componentId: "sc-1dd3hpp-7"
})([""]);
var StyledUpdates = _styledComponents["default"].div.withConfig({
  displayName: "BugsDropdown__StyledUpdates",
  componentId: "sc-1dd3hpp-8"
})(["border:1px solid #dceeff;border-radius:4px;background:#f0fbff;padding:4px 0;font-weight:bold;margin-bottom:5px;"]);
var StyledBugTitle = _styledComponents["default"].div.withConfig({
  displayName: "BugsDropdown__StyledBugTitle",
  componentId: "sc-1dd3hpp-9"
})(["flex:1;font-size:14px;padding-right:10px;overflow:hidden;text-overflow:ellipsis;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "BugsDropdown__StyledDescription",
  componentId: "sc-1dd3hpp-10"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:10px;text-align:left;color:#656565;"]);
var StyledBugTime = (0, _styledComponents["default"])(_TimeFrom["default"]).withConfig({
  displayName: "BugsDropdown__StyledBugTime",
  componentId: "sc-1dd3hpp-11"
})(["font-size:11px;"]);
var StyledLabel = _styledComponents["default"].span.withConfig({
  displayName: "BugsDropdown__StyledLabel",
  componentId: "sc-1dd3hpp-12"
})(["position:relative;z-index:3;"]);
var StyledHead = _styledComponents["default"].div.withConfig({
  displayName: "BugsDropdown__StyledHead",
  componentId: "sc-1dd3hpp-13"
})(["font-weight:bold;display:flex;align-items:center;display:flex;column-gap:5px;height:40px;padding:0 7px;border:solid 1px #c2c5cc;border-radius:4px;overflow:hidden;position:relative;> *{position:relative;z-index:3;}&[data-socket-error='true']{border:1px solid #ffb1c3;background:#fff0f0;&:before{content:'';position:absolute;top:0;left:0;width:40px;height:100%;background:#fff0f0;background:linear-gradient(90deg,#fff0f0 0%,#ffe4e4 50%,#fff0f0);animation:highlight-error 1.2s ease-in-out infinite;}}&[data-has-updates='true']{border:1px solid #92d8f0;background:#f0fbff;&:before{content:'';position:absolute;top:0;left:0;width:40px;height:100%;background:#f0fbff;background:linear-gradient(90deg,#f0fbff 0%,#dceeff 50%,#f0fbff);animation:highlight-error 1.2s ease-in-out infinite;}}@keyframes highlight-error{0%,100%{left:-100%;}50%{left:100%;}}"]);
var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "BugsDropdown__StyledContent",
  componentId: "sc-1dd3hpp-14"
})(["padding:10px 15px;width:400px;"]);